import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';


export const GlobalDodAgencyBasicInfoComponent = ({ dodProgramParticipants,channelPrograms,id,selectedGlobalDODMapping,handleInnerFormChange}: any) => {
  const upstreamProvider: any = [
    { Description: 'Brand Catalog', Value: 10 },
    { Description: 'Partner Catalog', Value: 20 },
    { Description: 'Hybrid Catalog', Value: 30 },
  ]

    const catalogType: any = [
    { Description: 'B2B', Value: 10 },
    { Description: 'B2C', Value: 20 },
      ]
    return (
        <>
            <AccordionContainer
                child={
                     
         <><div>
                        <InputLabelContainer label="Internal Global DBA Registry" />
                        <InputLabelContainer label={selectedGlobalDODMapping?.InternalGlobalDBARegistryName} />
                    </div><div>
                            <InputLabelContainer label="Partner Global DBA Registry " />
                            <InputLabelContainer label={selectedGlobalDODMapping?.PartnerGlobalDBARegistryName} />
                        </div></>
                }
                expandedPanel="Global DOD Agency Mapping"
                headerTitle="Global DOD Agency Mapping"
            />

             <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer
disabled
    label="Upstream Provider"
    name="IsUpstreamProvider"
    onValueChange={(event: any) => {
      handleInnerFormChange(
        event,
        'IsUpstreamProvider'
      )
    }}
    type="checkbox"
    value={selectedGlobalDODMapping?.IsUpstreamProvider}
/>
  {selectedGlobalDODMapping?.IsUpstreamProvider &&

    <InputContainer
    disabled
              label="UpStream Provider Name" 
              labelField="Description"
              list={upstreamProvider}
              onValueChange={(newValue: any) => {
                const countryData: any = newValue.map((option: any) => option?.value || '')
  
                 handleInnerFormChange(
                  countryData,
                  'UpstreamProviderIds'
                )
              }}
              type="multiselect"
              valueField="Value"
              value={selectedGlobalDODMapping?.UpstreamProviderIds}
          />
   
        }
</div>
  }
     expandedPanel="UpStream Provider Info"
     headerTitle="UpStream Provider Info"
 />

   <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
   <InputContainer
   disabled
              label="Channel Provider"
              name="IsChannelProvider"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsChannelProvider'
                )
              }}
              type="checkbox"
              value={selectedGlobalDODMapping?.IsChannelProvider}
          />
            {selectedGlobalDODMapping?.IsChannelProvider &&
    <InputContainer
    disabled
              label="Channel Provider Name"
              labelField="Name"
              list={channelPrograms}
              onValueChange={(newValue: any) => {
                const countryData: any = newValue.map((option: any) => option?.value || '')
  
                 handleInnerFormChange(
                  countryData,
                  'GlobalChannelProgramIds'
                )
              }}
              type="multiselect"
              value={selectedGlobalDODMapping?.GlobalChannelProgramIds}
              valueField="GlobalChannelProgramId"
          />
        }
    </div>

  }
     expandedPanel="Channel Provider Info"
     headerTitle="Channel Provider Info"
 />
    <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

   <InputContainer
              label="DOD Program Participant Network" 
              labelField="Name"
              list={dodProgramParticipants}
               onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                handleInnerFormChange(
                  event.target.value,
                  'GlobalDODProgramParticipantId'
                )
              }}
              optionName='Choose DOD Program Participant'
               type="select"
              valueField="GlobalDODProgramParticipantId"
              value={selectedGlobalDODMapping?.GlobalDODProgramParticipantId}
          />

         <InputContainer
              label="DOD Program Participant Type" 
              labelField="Description"
              list={catalogType}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                handleInnerFormChange(
                  event.target.value,
                  'GlobalDODProgramParticipantType'
                )
              }}
              optionName='Choose DOD Program Participant Type'
               type="select"
              valueField="Description"
              value={selectedGlobalDODMapping?.GlobalDODProgramParticipantType}
          />   
   
        
</div>
  }
     expandedPanel="DOD Program Participant Network"
     headerTitle="DOD Program Participant Network"
 />   
        </>
    )
}
export default GlobalDodAgencyBasicInfoComponent;
